import { render, staticRenderFns } from "./dialog-factory.vue?vue&type=template&id=d410a3e0"
import script from "./dialog-factory.vue?vue&type=script&lang=js"
export * from "./dialog-factory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports